import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [CommonModule, FormsModule, AmplifyAuthenticatorModule, RouterModule],
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginMode: 'email' | 'phone' = 'phone';
  credentials = { identifier: '', password: '' };
  error = '';
  isLoading = false;

  constructor(private auth: AuthService, private router: Router) { }

  setLoginMode(mode: 'email' | 'phone') {
    this.loginMode = mode;
    this.credentials.identifier = '';
    this.error = '';
  }

  async onLogin() {
    this.isLoading = true;
    this.error = '';

    try {
      const { isSignedIn } = await this.auth.login(this.credentials.identifier, this.credentials.password);
      if (isSignedIn) {
        this.router.navigate(['/aguai-2026/registration']);
      }
    } catch (err: any) {
      console.log(err);
      if (err.name === 'UserAlreadyAuthenticatedException' || err.message?.includes('already logged in')) {
        this.auth.isLoggedIn.set(true);
        this.router.navigate(['/aguai-2026/registration'])
        return;
      }

      this.error = err.message || 'Login failed';
    } finally {
      this.isLoading = false;
    }
  }

  onSocialLogin(provider: 'Google' | 'Apple') {
    this.auth.loginWithSocial(provider);
  }
}
